import React from 'react'
import styled from 'styled-components'

const TagButtonStyled = styled.button`
  border: none;
  cursor: pointer;
  height: 30px;
  font-size: 12px;
  font-weight: 400;
  padding: 6px 8px;
  background: transparent;
  transition: all 200ms;
  border: 0.5px solid ${({ theme }) => theme.bg3};
  color: rgb(195, 197, 203);

  &:hover {
    border: 0.5px solid #4afc39;
    color: #4afc39;
  }

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;

  display: flex;
  align-items: center;

  svg {
    margin-right: 4px;
  }
`

interface TagButtonI {
  onClick: () => void
  children: string | JSX.Element | JSX.Element[] | Element | Element[] | any
}

const TagButton: React.FC<TagButtonI> = ({ onClick, children }) => {
  return <TagButtonStyled onClick={() => onClick()}>{children}</TagButtonStyled>
}
export default TagButton
